const AURURIO_VARIANT_IMAGE_DATA_ID = 'AururioVariantImagePreloadData';
const AURURIO_VARIANT_IMAGE_DESKTOP_CONCURRENCY = 2;
const AURURIO_VARIANT_IMAGE_MOBILE_CONCURRENCY = 1;
const AURURIO_VARIANT_IMAGE_ACTIVE = new Map();
const AURURIO_VARIANT_IMAGE_READY = new Set();

function readAururioVariantImageRecords() {
  const element = document.getElementById(AURURIO_VARIANT_IMAGE_DATA_ID);
  if (!element?.textContent) return [];

  try {
    const records = JSON.parse(element.textContent);
    return Array.isArray(records) ? records : [];
  } catch (error) {
    console.warn('[Aururio Image Preload] Invalid image preload data.', error);
    return [];
  }
}

function getAururioGallerySizes() {
  const currentGalleryImage = document.querySelector(
    'media-gallery img.product-media__image, media-gallery img[srcset], media-gallery img'
  );

  return currentGalleryImage?.getAttribute('sizes') || '(min-width: 750px) 50vw, 100vw';
}

function getAururioColorInput(target) {
  if (!(target instanceof Element)) return null;

  if (target.matches('.variant-option--aururio-color input[data-option-value-id]')) {
    return target;
  }

  const colorLabel = target.closest('.variant-option--aururio-color .aururio-color-label');
  return colorLabel?.querySelector('input[data-option-value-id]') || null;
}

function preloadAururioVariantImage(record, priority = 'auto') {
  if (!record?.optionValueId || (!record.src && !record.srcset)) {
    return Promise.resolve(false);
  }

  const key = String(record.optionValueId);

  if (AURURIO_VARIANT_IMAGE_READY.has(key)) {
    return Promise.resolve(true);
  }

  const active = AURURIO_VARIANT_IMAGE_ACTIVE.get(key);
  if (active) {
    if (priority === 'high') {
      active.image.fetchPriority = 'high';
      active.image.setAttribute('fetchpriority', 'high');
    }
    return active.promise;
  }

  const image = new Image();
  image.decoding = 'async';
  image.fetchPriority = priority;
  image.setAttribute('fetchpriority', priority);

  const promise = new Promise((resolve) => {
    let settled = false;

    const finish = (loaded) => {
      if (settled) return;
      settled = true;

      AURURIO_VARIANT_IMAGE_ACTIVE.delete(key);
      if (loaded) AURURIO_VARIANT_IMAGE_READY.add(key);
      resolve(loaded);
    };

    image.addEventListener('load', () => finish(true), { once: true });
    image.addEventListener('error', () => finish(false), { once: true });

    image.sizes = getAururioGallerySizes();
    if (record.srcset) image.srcset = record.srcset;
    if (record.src) image.src = record.src;

    if (image.complete && image.naturalWidth > 0) {
      queueMicrotask(() => finish(true));
    }
  });

  AURURIO_VARIANT_IMAGE_ACTIVE.set(key, { image, promise });
  return promise;
}

const aururioVariantImageRecords = readAururioVariantImageRecords();
const aururioVariantImageByOption = new Map(
  aururioVariantImageRecords.map((record) => [String(record.optionValueId), record])
);

function handleAururioColorIntent(event) {
  const input = getAururioColorInput(event.target);
  if (!(input instanceof HTMLInputElement)) return;

  const record = aururioVariantImageByOption.get(String(input.dataset.optionValueId));
  if (!record) return;

  void preloadAururioVariantImage(record, 'high');
}

function preloadAururioAlternateColorImages() {
  const jobs = aururioVariantImageRecords.filter((record) => record.selected !== true);
  if (!jobs.length) return;

  let nextJobIndex = 0;
  const isMobile = window.matchMedia('(max-width: 749px)').matches;
  const maxConcurrency = isMobile
    ? AURURIO_VARIANT_IMAGE_MOBILE_CONCURRENCY
    : AURURIO_VARIANT_IMAGE_DESKTOP_CONCURRENCY;

  const worker = async () => {
    while (nextJobIndex < jobs.length) {
      const record = jobs[nextJobIndex++];
      await preloadAururioVariantImage(record, 'auto');
    }
  };

  const workerCount = Math.min(maxConcurrency, jobs.length);

  void Promise.all(Array.from({ length: workerCount }, () => worker())).then(() => {
    console.log(
      `[Aururio Image Preload] READY ${AURURIO_VARIANT_IMAGE_READY.size}/${jobs.length} alternate color images`
    );
  });
}

function scheduleAururioAlternateColorImages() {
  const runWhenIdle = () => {
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(() => preloadAururioAlternateColorImages(), { timeout: 3500 });
      return;
    }

    window.setTimeout(() => preloadAururioAlternateColorImages(), 1800);
  };

  if (document.readyState === 'complete') {
    runWhenIdle();
    return;
  }

  window.addEventListener('load', runWhenIdle, { once: true });
}

if (aururioVariantImageRecords.length) {
  document.addEventListener('pointerover', handleAururioColorIntent, { passive: true });
  document.addEventListener('pointerdown', handleAururioColorIntent, { passive: true });
  document.addEventListener('focusin', handleAururioColorIntent);

  scheduleAururioAlternateColorImages();
}
